import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IProps } from './models';
import { FormIterator as Component } from './form-iterator';

/** @widgetName FormIterator */
export const FormIterator = createWidget<unknown, IProps>()(Component);
